(function($){
    window.Forms = {
        ready: function () {

            this.Validators.ready();
            this.AmIHuman.ready();
            this.RadioWithTextInput.ready();

        },
        RadioWithTextInput: {
            ui: {
                container: '.js-radio-with-text-input',
                radio: '.js-radio-with-text-input__radio',
                text: '.js-radio-with-text-input__text',
            },
            ready: function (){

                var self = this;

                $(this.ui.text).on('change keypress', function(){
                    $(this).closest(self.ui.container).find(self.ui.radio).click();
                });

            }
        },
        AmIHuman: {
            ui: {
                form: 'form',
                input: 'input[name="_aih"]',
            },
            ready: function () {

                var self = this;

                $(document).on('submit', this.ui.form, function(){
                    // fill in the input value before submit
                    var $input = $(this).find(self.ui.input);
                    $input.val($input.attr('data-aih'));
                });

            }
        }
    }
})(jQuery);

// Initiate the application
jQuery(function () {
    Forms.ready();
});